import http from '../_http_v2';

const agent = {
  //default
  list: (m) => { return http.post(`console/webcastle/agent/list`, m); },
  detail: (m) => { return http.get(`console/webcastle/agent/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/webcastle/agent`, m); },
  update: (m) => { return http.put(`console/webcastle/agent`, m); },
  delete: (m) => { return http.delete(`console/webcastle/agent/${m.id}`); },

  //domain
  domainLimit: (m) => { return http.get(`console/webcastle/agent/domain`, m); },
  domainInfo: (m) => { return http.post(`console/webcastle/agent/domain/info`, m); },

  //policy
  crs: (m) => { return http.post(`console/webcastle/agent/crs`, m); },
  policy: (m) => { return http.put(`console/webcastle/agent/policy`, m); },

  agree: (m) => { return http.post(`console/webcastle/agent/agree`, m); },
  info: (m) => { return http.get(`console/webcastle/agent/info`, m); },
}

export default agent